export default function LoadingScreen() {
  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginTop: 10,
          marginBottom: 10,
        }}
      >
        <h4>Loading...</h4>
      </div>
    </>
  );
}
